import client from "./api-client";
import { queryCache } from "react-query";

const REFRESH_TOKEN = "__hayat_refreshtoken__";
const ACCESS_TOKEN = "__hayat_accesstoken__";

async function refreshAccessToken() {
  const refreshToken = window.localStorage.getItem(REFRESH_TOKEN);
  if (refreshToken) {
    return client(`auth/refresh?refreshtoken=${refreshToken}`)
      .then((data) => {
        const { accessToken } = data;
        window.localStorage.setItem(ACCESS_TOKEN, accessToken);
      })
      .catch(() => {});
  }
}

// silently refreshs the access token
// so that we don't get logged out
function silentRefresh() {
  setTimeout(() => {
    refreshAccessToken();
    silentRefresh();
  }, 60000);
}

silentRefresh();

async function handleUserResponse(tokenData) {
  const { accessToken, refreshToken } = tokenData;
  window.localStorage.setItem(REFRESH_TOKEN, refreshToken);
  window.localStorage.setItem(ACCESS_TOKEN, accessToken);
  // TODO server should return complelte user
  // in login
  const user = await getUser();
  return user;
}

async function getUser() {
  const token = getToken();
  if (!token) {
    return Promise.resolve(null);
  }
  await refreshAccessToken();
  return client("account").catch((error) => {
    logout();
    return Promise.reject(error);
  });
}

function login({ phoneNumber, password, rememberMe }) {
  return client("auth/login", {
    body: { phoneNumber, password, rememberMe },
  }).then(handleUserResponse);
}

function register({
  firstName,
  lastName,
  phoneNumber,
  password,
  confirmPassword,
}) {
  return client("register", {
    body: { firstName, lastName, phoneNumber, password, confirmPassword },
  }).then(handleUserResponse);
}

function logout() {
  window.localStorage.removeItem(REFRESH_TOKEN);
  window.localStorage.removeItem(ACCESS_TOKEN);
  queryCache.clear();
  return Promise.resolve();
}

function getToken() {
  return window.localStorage.getItem(REFRESH_TOKEN);
}

function isLoggedIn() {
  return Boolean(getToken());
}

export { login, register, logout, getToken, getUser, isLoggedIn };
